<template>
  <div class="fillcontain">
    <head-top></head-top>
    <div class="man-cell" style="margin: 10px">
      <el-input v-model="name" placeholder="媒体名称："></el-input>
    </div>
    <el-button style="margin: 10px" type="primary" @click="getMedia(self)">搜索</el-button>
    <div class="table_container">
      <el-tabs value="all" @tab-click="handleClick">
		<el-tab-pane label="全部" name="all"></el-tab-pane>
        <el-tab-pane label="待审核" name="second"></el-tab-pane>
        <el-tab-pane label="未通过" name="thrid"></el-tab-pane>
        <el-tab-pane label="已通过" name="four"></el-tab-pane>
        <el-tab-pane label="已删除" name="first"></el-tab-pane>
        <!-- <el-button type="primary" @click="gotowithdrawal">收益查看</el-button> -->
        <el-table :data="tableData" highlight-current-row style="width: 100%" v-loading="loading">
          <el-table-column property="name" label="媒体名称"></el-table-column>
                  <el-table-column label="媒体类型" width="80%">
          <template slot-scope="scope">
            <a v-if="scope.row.mediaType==1">媒体</a>
            <a v-else-if="scope.row.mediaType==2">自媒体</a>
            <a v-else-if="scope.row.mediaType==3">微信公众号</a>
            <a v-else-if="scope.row.mediaType==4">微博</a>
            <a v-else-if="scope.row.mediaType==5">百科</a>
            <a v-else-if="scope.row.mediaType==6">朋友圈社群</a>
            <a v-else-if="scope.row.mediaType==7">短视频</a>
          </template>
        </el-table-column>
          <el-table-column property="channel" label="频道类型"></el-table-column>
          <el-table-column property="area" label="地区"></el-table-column>
          <el-table-column property="linkable" label="是否带链接"></el-table-column>
          <el-table-column property="contactable" label="带联系方式"></el-table-column>
          <el-table-column property="rate" label="出稿率"></el-table-column>
          <el-table-column property="speed" label="出稿速度"></el-table-column>
          <el-table-column property="included" label="收录类型"></el-table-column>
          <el-table-column label="审核状态">
            <template slot-scope="scope">
              <p>{{ scope.row.state }}</p>
              <el-button
                v-if="scope.row.state == '未通过' && !scope.row.selfMedia"
                @click="edit(scope.$index, scope.row)"
                size="mini"
              >修改</el-button>
              <el-button
                v-if="scope.row.state == '未通过' && scope.row.selfMedia"
                @click="edit2(scope.$index, scope.row)"
                size="mini"
              >修改</el-button>
            </template>
          </el-table-column>
          <el-table-column property="reason" label="原因"></el-table-column>
        </el-table>
        <div class="Pagination" style="text-align: left; margin-top: 10px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="index"
            :page-size="20"
            layout="total, prev, pager, next"
            :total="count"
          ></el-pagination>
        </div>
      </el-tabs>
    </div>
    <el-dialog title="添加/修改媒体" :visible.sync="dialogVisible" width="50%">
      <el-form ref="form" label-width="100px">
        <el-form-item label="媒体名称：" style="width: 50%; float: left">
          <el-input style="width: 80%" size="small" v-model="mname"></el-input>
        </el-form-item>
        <el-form-item label="价格：" style="width: 50%; float: left">
          <el-input style="width: 80%" size="small" v-model="mprice"></el-input>
        </el-form-item>
        <el-form-item label="投放类型" style="width: 50%; float: left">
          <el-select v-model="lanuch" placeholder="请选择">
            <el-option
              v-for="item in lanuchList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="其他选项：" style="width: 50%; float: left">
          <el-select v-model="others" placeholder="请选择">
            <el-option
              v-for="item in othersList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="频道类型：" style="width: 50%; float: left">
          <el-select v-model="pindao" placeholder="请选择">
            <el-option
              v-for="item in pindaoList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="地区：" style="width: 50%; float: left">
          <el-select v-model="area" placeholder="请选择">
            <el-option
              v-for="item in areaList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="门户：" style="width: 50%; float: left">
          <el-select v-model="portal" placeholder="请选择">
            <el-option
              v-for="item in portalList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="带链接：" style="width: 50%; float: left">
          <el-select v-model="link" placeholder="请选择">
            <el-option
              v-for="item in linkList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="带联系方式：" style="width: 50%; float: left">
          <el-select v-model="contactable" placeholder="请选择">
            <el-option
              v-for="item in contactableList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收录类型：" style="width: 50%; float: left">
          <el-select v-model="included" placeholder="请选择">
            <el-option
              v-for="item in includedList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="是否认证：" style="width:50%;float:left">
          <el-select v-model="auth" placeholder="请选择">
            <el-option
              v-for="item in authList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>-->
        <el-form-item label="案例链接：" style="clear: both">
          <el-input style="width: 80%" type="textarea" size="small" v-model="linkcase"></el-input>
        </el-form-item>
        <el-form-item label="备注：" style="clear: both">
          <el-input style="width: 80%" type="textarea" size="small" v-model="content"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button v-show="dialogVisible2" type="primary" @click="sureadd(self)">确认添加</el-button>
        <el-button v-show="!dialogVisible2" type="primary" @click="sureedit(self)">确认修改</el-button>
      </span>
    </el-dialog>
    <el-dialog title="添加/修改媒体" :visible.sync="dialogVisible_2" width="50%">
      <el-form ref="form" label-width="100px">
        <el-form-item label="媒体名称：" style="width: 50%; float: left">
          <el-input style="width: 80%" size="small" v-model="mname2"></el-input>
        </el-form-item>
        <el-form-item label="价格：" style="width: 50%; float: left">
          <el-input style="width: 80%" size="small" v-model="mprice2"></el-input>
        </el-form-item>
        <el-form-item label="行业类型：" style="width: 50%; float: left">
          <el-select v-model="pindao2" placeholder="请选择">
            <el-option
              v-for="item in pindaoList2"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="粉丝数：" style="width: 50%; float: left">
          <el-select v-model="area2" placeholder="请选择">
            <el-option
              v-for="item in areaList2"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="投放类型" style="width: 50%; float: left">
          <el-select v-model="lanuch2" placeholder="请选择">
            <el-option
              v-for="item in lanuchList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="其他选项：" style="width: 50%; float: left">
          <el-select v-model="others2" placeholder="请选择">
            <el-option
              v-for="item in othersList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属平台：" style="width: 50%; float: left">
          <el-select v-model="portal2" placeholder="请选择">
            <el-option
              v-for="item in portalList2"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="带链接：" style="width: 50%; float: left">
          <el-select v-model="link2" placeholder="请选择">
            <el-option
              v-for="item in linkList2"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="带联系方式：" style="width: 50%; float: left">
          <el-select v-model="contactable2" placeholder="请选择">
            <el-option
              v-for="item in contactableList2"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="参考阅读量：" style="width: 50%; float: left">
          <el-select v-model="included2" placeholder="请选择">
            <el-option
              v-for="item in includedList2"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="是否认证：" style="width:50%;float:left">
          <el-select v-model="auth2" placeholder="请选择">
            <el-option
              v-for="item in authList2"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>-->
        <el-form-item label="案例链接：" style="clear: both">
          <el-input style="width: 80%" type="textarea" size="small" v-model="linkcase2"></el-input>
        </el-form-item>
        <el-form-item label="备注：" style="clear: both">
          <el-input style="width: 80%" type="textarea" size="small" v-model="content2"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible_2 = false">取 消</el-button>
        <el-button v-show="dialogVisible2" type="primary" @click="sureadd2(self)">确认添加</el-button>
        <el-button v-show="!dialogVisible2" type="primary" @click="sureedit2(self)">确认修改</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import HeadTop from "../components/HeadTop";
import myAxios from "../myAxios";
export default {
  data() {
    return {
      name: "",
      state:4,
      linkcase: "",
      linkcase2: "",
      self: false,
      dialogVisible2: false,
      mname: "",
      mprice: "",
      sousuo: "",
      mname2: "",
      mprice2: "",
      sousuo2: "",
      username: localStorage.getItem("username"),
      url: localStorage.getItem("url"),
      tableData: [], //用户列表数据
      index: 1, //页码
      size: 20, //页大小
      count: 0, //数据总数
      loading: false, //加载状态
      detail: [],
      dialogVisible: false,
      dialogVisible_2: false,
      content: "",
      content2: "",
      lanuch: "不限",
      lanuch2: "不限",
      lanuchList: [
        { value: "不限", label: "不限" },
        { value: "转载", label: "转载" },
        { value: "首发", label: "首发" },
        { value: "焦点图", label: "焦点图" },
        { value: "文字链", label: "文字链" }
      ],
      others: "不限",
      others2: "不限",
      othersList: [
        { value: "不限", label: "不限" },
        { value: "周末可发", label: "周末可发" },
        { value: "秒发", label: "秒发" },
        { value: "节假日可发", label: "节假日可发" }
      ],
      pindaoList2: [
        {
          value: "新闻资讯",
          label: "新闻资讯"
        },
        {
          value: "财经金融",
          label: "财经金融"
        },
        {
          value: "3C科技",
          label: "3C科技"
        },
        {
          value: "家居房产",
          label: "家居房产"
        },
        {
          value: "时尚女性",
          label: "时尚女性"
        },
        {
          value: "母婴健康",
          label: "母婴健康"
        },
        {
          value: "汽车娱乐",
          label: "汽车娱乐"
        },
        {
          value: "教育体育",
          label: "教育体育"
        },
        {
          value: "文化旅游",
          label: "文化旅游"
        },
        {
          value: "生活美食",
          label: "生活美食"
        },
        {
          value: "游戏动漫",
          label: "游戏动漫"
        },
        {
          value: "其他",
          label: "其他"
        }
      ],
      pindao: "",
      areaList2: [
        {
          value: "1万以下",
          label: "1万以下"
        },
        {
          value: "1万-5万",
          label: "1万-5万"
        },
        {
          value: "5万-10万",
          label: "5万-10万"
        }
      ],
      area: "",
      linkList: [
        {
          value: true,
          label: "是"
        },
        {
          value: false,
          label: "否"
        }
      ],
      link: true,
      contactableList: [
        {
          value: true,
          label: "是"
        },
        {
          value: false,
          label: "否"
        }
      ],
      contactable: true,
      includedList2: [
        {
          value: "1000以下",
          label: "1000以下"
        },
        {
          value: "1000-5000",
          label: "1000-5000"
        },
        {
          value: "5000-1万",
          label: "5000-1万"
        }
      ],
      included: "",
      authList: [
        {
          value: true,
          label: "是"
        },
        {
          value: false,
          label: "否"
        }
      ],
      auth: true,
      portalList: [
        {
          value: "新浪",
          label: "新浪"
        },
        {
          value: "网易",
          label: "网易"
        },
        {
          value: "腾讯",
          label: "腾讯"
        },
        {
          value: "搜狐",
          label: "搜狐"
        },
        {
          value: "中国网",
          label: "中国网"
        },
        {
          value: "中国经济网",
          label: "中国经济网"
        },
        {
          value: "人民网",
          label: "人民网"
        },
        {
          value: "新华网",
          label: "新华网"
        },
        {
          value: "光明网",
          label: "光明网"
        },
        {
          value: "中国日报网",
          label: "中国日报网"
        },
        {
          value: "国际在线",
          label: "国际在线"
        },
        {
          value: "央视网",
          label: "央视网"
        },
        {
          value: "和讯网",
          label: "和讯网"
        },
        {
          value: "中华网",
          label: "中华网"
        },
        {
          value: "北青网",
          label: "北青网"
        },
        {
          value: "环球网",
          label: "环球网"
        },
        {
          value: "其他门户",
          label: "其他门户"
        }
      ],
      portal: "",
      pindaoList: [
        {
          value: "新闻资讯",
          label: "新闻资讯"
        },
        {
          value: "金融财经",
          label: "金融财经"
        },
        {
          value: "IT科技",
          label: "IT科技"
        },
        {
          value: "房产家居",
          label: "房产家居"
        },
        {
          value: "娱乐",
          label: "娱乐"
        },
        {
          value: "女性时尚",
          label: "女性时尚"
        },
        {
          value: "生活消费",
          label: "生活消费"
        },
        {
          value: "游戏动漫",
          label: "游戏动漫"
        },
        {
          value: "汽车",
          label: "汽车"
        },
        {
          value: "医疗健康",
          label: "医疗健康"
        },
        {
          value: "体育",
          label: "体育"
        },
        {
          value: "亲子母婴",
          label: "亲子母婴"
        },
        {
          value: "教育",
          label: "教育"
        },
        {
          value: "区块链",
          label: "区块链"
        },
        {
          value: "艺术文化",
          label: "艺术文化"
        },
        {
          value: "餐饮食品",
          label: "餐饮食品"
        },
        {
          value: "其他",
          label: "其他"
        }
      ],
      pindao2: "",
      areaList: [
        { value: "全国", label: "全国" },
        { value: "北京", label: "北京" },
        { value: "上海", label: "上海" },
        { value: "深圳", label: "深圳" },
        { value: "广州", label: "广州" },
        { value: "杭州", label: "杭州" },
        { value: "天津", label: "天津" },
        { value: "成都", label: "成都" },
        { value: "重庆", label: "重庆" },
        { value: "长沙", label: "长沙" },
        { value: "武汉", label: "武汉" },
        { value: "苏州", label: "苏州" },
        { value: "西安", label: "西安" },
        { value: "南京", label: "南京" },
        { value: "沈阳", label: "沈阳" },
        { value: "青岛", label: "青岛" },
        { value: "四川", label: "四川" },
        { value: "河北", label: "河北" },
        { value: "贵州", label: "贵州" },
        { value: "山西", label: "山西" },
        { value: "云南", label: "云南" },
        { value: "辽宁", label: "辽宁" },
        { value: "陕西", label: "陕西" },
        { value: "吉林", label: "吉林" },
        { value: "甘肃", label: "甘肃" },
        { value: "广西", label: "广西" },
        { value: "内蒙古", label: "内蒙古" },
        { value: "新疆", label: "新疆" },
        { value: "黑龙江", label: "黑龙江" },
        { value: "青海", label: "青海" },
        { value: "西藏", label: "西藏" },
        { value: "澳门", label: "澳门" },
        { value: "香港", label: "香港" },
        { value: "海外媒体", label: "海外媒体" },
        { value: "其他", label: "其他" }
      ],
      area2: "",
      linkList2: [
        {
          value: true,
          label: "是"
        },
        {
          value: false,
          label: "否"
        }
      ],
      link2: true,
      contactableList2: [
        {
          value: true,
          label: "是"
        },
        {
          value: false,
          label: "否"
        }
      ],
      contactable2: true,
      includedList: [
        {
          value: "包网页收录",
          label: "包网页收录"
        },
        {
          value: "网页收录",
          label: "网页收录"
        },
        {
          value: "百度新闻收录",
          label: "百度新闻收录"
        },
        {
          value: "包百度新闻收录",
          label: "包百度新闻收录"
        }
      ],
      included2: "",
      authList2: [
        {
          value: true,
          label: "是"
        },
        {
          value: false,
          label: "否"
        }
      ],
      auth2: true,
      portalList2: [
        {
          value: "新浪微博",
          label: "新浪微博"
        },
        {
          value: "微信微信公众号",
          label: "微信微信公众号"
        },
        {
          value: "今日头条",
          label: "今日头条"
        },
        {
          value: "百度百家",
          label: "百度百家"
        },
        {
          value: "网易号",
          label: "网易号"
        },
        {
          value: "腾讯号",
          label: "腾讯号"
        },
        {
          value: "新浪头条",
          label: "新浪头条"
        },
        {
          value: "搜狐头条",
          label: "搜狐头条"
        },
        {
          value: "一点资讯",
          label: "一点资讯"
        },
        {
          value: "雪球号",
          label: "雪球号"
        },
        {
          value: "UC头条",
          label: "UC头条"
        },
        {
          value: "凤凰号",
          label: "凤凰号"
        },
        {
          value: "知乎号",
          label: "知乎号"
        },
        {
          value: "其他",
          label: "其他"
        }
      ],
      portal2: ""
    };
  },
  components: {
    HeadTop
  },
  created() {
    this.initData();
  },
  methods: {
    async initData() {
      try {
        this.getMedia();
      } catch (err) {
        console.log("获取数据失败", err);
      }
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(val);
      this.index = val;
      this.getMedia(false);
    },
    async getMedia() {
      myAxios
        .get(`/client_media/MyOtherMedia/v1?username=${this.username}&state=${this.state}&name=${this.name}`)
        .then(res => {
          this.tableData = res.data;
          this.count = res.total;
        });
      this.loading = false;
    },
    gotowithdrawal() {
      this.$router.push({ path: "/withdrawal" });
    },
    edit(index, row) {
      console.log(index, row);
      this.dialogVisible = true;
      this.dialogVisible2 = false;
      this.detail = row;
      this.area = row.area;
      this.pindao = row.channel;
      this.included = row.included;
      this.mname = row.name;
      this.portal = row.portal;
      this.mprice = row.price;
      this.content = row.remark;
      this.linkcase = row.mediaCase;
    },
    edit2(index, row) {
      console.log(index, row);
      this.dialogVisible_2 = true;
      this.dialogVisible2 = false;
      this.detail = row;
      this.area2 = row.area;
      this.pindao2 = row.channel;
      this.included2 = row.included;
      this.mname2 = row.name;
      this.portal2 = row.portal;
      this.mprice2 = row.price;
      this.content2 = row.remark;
      this.linkcase = row.mediaCase;
    },
    dele(index, row, selfMedia) {
      console.log(index, row);
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        myAxios
          .post(
            `/client_media/DeleteMedia/v1?username=${this.username}&mediaId=${row.id}`
          )
          .then(res => {
            if (res.code == 0) {
              this.$message({
                type: "success",
                message: res.data
              });
              this.mname == "";
              this.area == "";
              this.pindao == "";
              this.included == "";
              this.mprice == "";
              this.portal == "";
              this.getMedia(selfMedia);
            } else {
              this.$message({
                type: "success",
                message: res.message
              });
            }
          });
      });
    },
    sureadd(selfMedia) {
      if (
        this.mname == "" ||
        this.area == "" ||
        this.pindao == "" ||
        this.included == "" ||
        this.mprice == "" ||
        this.portal == ""
      ) {
        this.$alert("信息填写不全", "提示", {
          confirmButtonText: "确定"
        });
        return;
      }
      if (this.mprice <= 0) {
        this.$alert("金额不小于0", "提示", {
          confirmButtonText: "确定"
        });
        return;
      }
      myAxios
        .post(
          `/client_media/AddMedia/v1?username=${this.username}&selfMedia=${selfMedia}&area=${this.area}&channel=${this.pindao}&contactable=${this.contactable}&included=${this.included}&linkable=${this.link}&name=${this.mname}&portal=${this.portal}&price=${this.mprice}&remark=${this.content}&mediaCase=${this.linkcase}&lanuch=${this.lanuch}&others=${this.others}`
        )
        .then(res => {
          if (res.code == 0) {
            this.$message({
              type: "success",
              message: res.data
            });
            this.getMedia(selfMedia);
            this.mname = "";
            this.area = "";
            this.pindao = "";
            this.included = "";
            this.mprice = "";
            this.portal = "";
            this.linkcase = "";
            this.content = "";
            this.dialogVisible = false;
          } else {
            this.$message({
              type: "success",
              message: res.message
            });
          }
        });
    },
    sureedit(selfMedia) {
      console.log("this.mprice");
      console.log(this.mprice);
      if (
        this.mname == "" ||
        this.area == "" ||
        this.pindao == "" ||
        this.included == "" ||
        this.mprice == "" ||
        this.portal == ""
      ) {
        this.$alert("信息填写不全", "提示", {
          confirmButtonText: "确定"
        });
        return;
      }
      if (this.mprice <= 0) {
        this.$alert("金额不小于0", "提示", {
          confirmButtonText: "确定"
        });
        return;
      }
      myAxios
        .post(
          `/client_media/UpdateMedia/v1?username=${this.username}&mediaId=${this.detail.id}&area=${this.area}&channel=${this.pindao}&contactable=${this.contactable}&included=${this.included}&linkable=${this.link}&name=${this.mname}&portal=${this.portal}&price=${this.mprice}&remark=${this.content}&mediaCase=${this.linkcase}&lanuch=${this.lanuch}&others=${this.others}`
        )
        .then(res => {
          if (res.code == 0) {
            this.$message({
              type: "success",
              message: res.data
            });
            this.mname == "";
            this.area == "";
            this.pindao == "";
            this.included == "";
            this.mprice == "";
            this.portal == "";
            this.getMedia(selfMedia);
            this.dialogVisible = false;
          } else {
            this.$message({
              type: "success",
              message: res.message
            });
          }
        });
    },
    sureadd2(selfMedia) {
      console.log(this.mprice2);
      if (
        this.mname2 == "" ||
        this.area2 == "" ||
        this.pindao2 == "" ||
        this.included2 == "" ||
        this.mprice2 == "" ||
        this.portal2 == ""
      ) {
        this.$alert("信息填写不全", "提示", {
          confirmButtonText: "确定"
        });
        return;
      }
      if (this.mprice2 == 0) {
        this.$alert("金额不小于0", "提示", {
          confirmButtonText: "确定"
        });
        return;
      }
      myAxios
        .post(
          `/client_media/AddMedia/v1?username=${this.username}&selfMedia=${selfMedia}&area=${this.area2}&channel=${this.pindao2}&contactable=${this.contactable2}&included=${this.included2}&linkable=${this.link2}&name=${this.mname2}&portal=${this.portal2}&price=${this.mprice2}&remark=${this.content2}&mediaCase=${this.linkcase2}&lanuch=${this.lanuch2}&others=${this.others2}`
        )
        .then(res => {
          if (res.code == 0) {
            this.$message({
              type: "success",
              message: res.data
            });
            this.getMedia(selfMedia);
            this.mname2 = "";
            this.area2 = "";
            this.pindao2 = "";
            this.included2 = "";
            this.mprice2 = "";
            this.portal2 = "";
            this.linkcase2 = "";
            this.content2 = "";
            this.dialogVisible_2 = false;
          } else {
            this.$message({
              type: "success",
              message: res.message
            });
          }
        });
    },
    sureedit2(selfMedia) {
      if (
        this.mname2 == "" ||
        this.area2 == "" ||
        this.pindao2 == "" ||
        this.included2 == "" ||
        this.mprice2 == "" ||
        this.portal2 == ""
      ) {
        this.$alert("信息填写不全", "提示", {
          confirmButtonText: "确定"
        });
        return;
      }
      myAxios
        .post(
          `/client_media/UpdateMedia/v1?username=${this.username}&mediaId=${this.detail.id}&area=${this.area2}&channel=${this.pindao2}&contactable=${this.contactable2}&included=${this.included2}&linkable=${this.link2}&name=${this.mname2}&portal=${this.portal2}&price=${this.mprice2}&remark=${this.content2}&mediaCase=${this.linkcase2}&lanuch=${this.lanuch2}&others=${this.others2}`
        )
        .then(res => {
          if (res.code == 0) {
            this.$message({
              type: "success",
              message: res.data
            });
            this.mname2 == "";
            this.area2 == "";
            this.pindao2 == "";
            this.included2 == "";
            this.mprice2 == "";
            this.portal2 == "";
            this.linkcase2 = "";
            this.content2 = "";
            this.getMedia(selfMedia);
            this.dialogVisible_2 = false;
          } else {
            this.$message({
              type: "success",
              message: res.message
            });
          }
        });
    },
    handleClick(tab, event) {
      console.log(tab);
	  var num=tab.index
	  if(num<=0){num=4}
    else if(num==4){num=0}
      this.state=num
      this.getMedia();
    }
  }
};
</script>

<style lang="less">
@import "../style/mixin";
.table_container {
  padding: 20px;
}
.yrz {
  color: #fd5353;
  border: 1px solid #fd5353;
  border-radius: 5px;
  font-size: 9pt;
  padding: 1px;
}
.wrz {
  background-color: #bdbdbd;
  color: #ffffff;
  border-radius: 5px;
  font-size: 9pt;
  padding: 1px;
}
</style>
